// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._skeleton_11bo4_1 {
  --pa-vehicle-header-skeleton-border-width-inner: var(--pa-vehicle-header-skeleton-border-width, 0);
  --perxis-auto-header-border-width: var(--pa-vehicle-header-skeleton-border-width-inner);
  --perxis-auto-header-padding: 0;
}
._skeleton__title_11bo4_6 {
  width: 180px;
  height: 28px;
}
@media (min-width: 1200px) {
  ._skeleton__title_11bo4_6 {
    width: 330px;
    height: 42px;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  ._skeleton__title_11bo4_6 {
    width: 250px;
    height: 32px;
  }
}
@media (min-width: 576px) and (max-width: 991px) {
  ._skeleton__title_11bo4_6 {
    width: 200px;
    height: 28px;
  }
}
._skeleton__description_11bo4_28 {
  width: 150px;
  height: 20px;
}
._skeleton__back_11bo4_32 {
  width: 120px;
  height: 24px;
}
._skeleton__markers_11bo4_36 {
  width: 120px;
  height: 24px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
